import { Grid, Typography, Box } from "@mui/material";

import standalonePhoto from "../../../static/images/distant_bass_suite/standalone-background.webp"
import asioLogo from "../../../static/images/distant_bass_suite/asio-logo.jpg"

const StandAloneBanner = () => {
  const textColor = "#000"
  return <Grid id="cabBanner" container sx={{ width: "100%", pt: 0, pb: 0, background: "#fff" }} justifyContent={"center"} >

    <Grid item xs={12} md={10}>
      <Grid container sx={{ width: "100%" }} alignItems={"center"} justifyContent={"center"}>

        <Grid item xs={12} md={5} sx={{ p: { xs: 4, md: 6 }, color: textColor, mb: "0 !important", textAlign: { xs: "center", md: "left" } }}>
          <Typography variant="h3" sx={{ fontWeight: "bold", color: textColor }}>No Dependencies</Typography>
          <Typography fontFamily={"montserrat"} sx={{ textAlign: "left", mt: 2, color: textColor, fontSize: { md: "24px", xs: "16px" } }}>Don't have access to either a VST3, AAX or AU host? No worries, you can still run the amplifier all on its own! </Typography>
          <Typography fontFamily={"montserrat"} sx={{ textAlign: "left", mt: 2, color: textColor, fontSize: { md: "24px", xs: "16px" } }}>A fully standalone version is included with your download. </Typography>

          <Box sx={{ mt: { xs: 5, md: 7 }, pt: 4, borderTop: "1px solid rgba(0, 0, 0, 0.18)", textAlign: "left" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: textColor }}>System Requirements</Typography>
            <Box sx={{ display: "flex", flexDirection: "column", rowGap: 1, mt: 2, mb: 2 }}>
              <Box><b>Formats:</b> BassSuite - Distant is available in 64-bit VST3, AU, AAX and Standalone format.</Box>
              <Box><b>OS:</b> Windows® 10 64 Bit (latest update) or MacOS® 10.13+</Box>
              <Box><b>Processor:</b> Minimum AVX support (Intel Haswell® or AMD Excavator® and up)</Box>
              <Box><b>Memory:</b> 8 GB</Box>
              <Box><b>Storage:</b> 4GB+ of free space</Box>
              <Box><b>Account:</b> A Free WaveMind account is required to register your license.</Box>
              <Box><b>Internet:</b> An internet connection required to activate your license through your WaveMind account.</Box>
            </Box>
            <Typography fontSize={12}><b>Note: </b>these specs are estimates and are considered the bare minimum. For a better experience, higher specs are recommended.</Typography>
            <Box component="img" loading="lazy" alt="ASIO" src={asioLogo} sx={{ display: "block", width: "50px", height: "auto", mt: 1.5 }} />
          </Box>
        </Grid>
        <Grid item xs={12} md={5} sx={{ p: { xs: 0, md: 4 }, color: textColor, display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            loading="lazy"
            alt="BassSuite - Distant standalone application running on a laptop"
            src={standalonePhoto}
            sx={{
              display: "block",
              width: "100%",
              maxWidth: "620px",
              height: "auto",
              borderRadius: 2,
              boxShadow: "0 20px 50px rgba(0, 0, 0, 0.28)",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
}

export default StandAloneBanner;
